export { default as HeaderOne } from './HeaderOne';
export { default as HeaderTwo } from './HeaderTwo';
export { default as HeaderThree } from './HeaderThree';
export { default as ProfileImage } from './ProfileImage';
export { default as ProfileInfo } from './ProfileInfo';
export { default as SocialIcon } from './SocialIcon';
export { default as QrCode } from './QrCode';
export { default as About } from './About';
export { default as Contact } from './Contact';
export { default as Skills } from './Skills';
export { default as Languages } from './Languages';
export { default as Hobbies } from './Hobbies';
export { default as Education } from './Education';
export { default as Experience } from './Experience';
export { default as Reference } from './Reference';
export { default as Tools } from './Tools';
export { default as Awards } from './Awards';


